import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import MainMenu_Home from "../../../../layout/menu/sections/home/menu-home";
import Navigation_ButtonGenericDeprecated from "../../../../layout/navigation/buttons/generic-section";
import {navigationStructureOnClick} from "../../navigation/actions/navigation-structure-on-click";
import {GroupedData} from "../../../data-structures/group";
import NavigationMenuSearch from "../../../../layout/search/sections/navigation-menu/navigation-menu-search";
import mainMenu_homeViews from "../../../../layout/menu/actions/home-views";
import Pin from "../../pin/pin";
import {PinLocationTypes} from "../../pin/@types";

export class SpaceHome extends SpaceProto {

    constructor() {
        super(NavigationSectionType.HOME)

        this.positions = []

        this.title = "Home"

        this.defaultPosition    = NavigationButtonPosition.STATIC
    }

    onClick = () => {
        navigationStructureOnClick(this.navigation)
    }

    get position(): NavigationButtonPosition {
        return NavigationButtonPosition.STATIC
    }

    get hasSearch() {
        return false
    }

    get navigationStructureConfig() {
        return {
            id              : this.id,
            icon            : "i5-nav-home",
            iconActive      : "i5-nav-home-solid",
            hint            : gd.t('menu.home.hint'),
            keyboardShortcut: 'H',
            menuComponent   : MainMenu_Home,
            renderComponent : Navigation_ButtonGenericDeprecated,
            type            : NavigationSectionType.HOME,
            // onClick         : navigationStructureOnClick,
            onClick         : this.onClick,
            position        : NavigationButtonPosition.STATIC
        }
    }

    async search(keyword: string): Promise<GroupedData> {


        let pinnedItems = _.filter(gd.session.pins.models, (pin: Pin)=>{

            if (pin.companyId !== gd.companyId) return false
            return pin.location.type === PinLocationTypes.HOME && (!!pin.task || !!pin.document || !!pin.user || !!pin.project)
        });

        const homeViews = mainMenu_homeViews()

        return await new NavigationMenuSearch(keyword,this).search([], pinnedItems, [], homeViews)
    }

}
